<template>
  <BreezeGuestLayout>
    <Head title="Log in" />

    <BreezeValidationErrors class="mb-4" />

    <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
      {{ status }}
    </div>

    <form @submit.prevent="submit">
      <div
        class="
          flex flex-column
          justify-content-center
          align-items-center
          guest-forms
          w-9
          md:w-5
          lg:w-3
          mx-auto
        "
      >
        <h1>LOG IN</h1>
        <span class="p-float-label mb-4 w-full">
          <InputText
            id="username"
            type="email"
            v-model="form.email"
            class="w-full"
            autofocus
          />
          <label for="username">Username</label>
        </span>
        <span class="p-float-label w-full">
          <InputText
            id="username"
            type="password"
            v-model="form.password"
            class="w-full"
          />
          <label for="username">Password</label>
        </span>

        <Button
          label="ENTRA"
          class="
            p-button-raised p-button-rounded p-button-secondary
            mt-4
            w-full
          "
          :class="{ 'opacity-25': form.processing }"
          :disabled="form.processing"
          type="submit"
        />
        <div class="text-center mt-4 w-full">
          <Link
            v-if="canResetPassword"
            :href="route('password.request')"
            class="underline text-sm hover:text-gray-900"
          >
            HO DIMENTICATO LA PASSWORD
          </Link>
        </div>
        <div class="text-center mt-4 w-full">
          <Link
            class="underline text-sm hover:text-gray-900"
            :href="route('register')"
          >
            NON POSSIEDO UN ACCOUNT
          </Link>
        </div>
      </div>
    </form>

    <template #footer v-if="$page.props.app_env === 'local'">
      <form :action="route('login')" method="post">
        <input type="hidden" name="_token" :value="$page.props.csrf_token" />
        <input type="hidden" name="password" value="password" />
        <Button type="submit" name="email" value="admin@example.com">Login ADMIN</Button>
        <Button type="submit" name="email" value="user@example.com">Login USER</Button>
      </form>
    </template>
  </BreezeGuestLayout>
</template>

<script>
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import BreezeButton from "@/Components/Button.vue";
import BreezeCheckbox from "@/Components/Checkbox.vue";
import BreezeGuestLayout from "@/Layouts/Guest.vue";
import BreezeInput from "@/Components/Input.vue";
import BreezeLabel from "@/Components/Label.vue";
import BreezeValidationErrors from "@/Components/ValidationErrors.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";

export default {
  components: {
    BreezeGuestLayout,
    BreezeButton,
    BreezeCheckbox,
    BreezeInput,
    InputText,
    Button,
    BreezeLabel,
    BreezeValidationErrors,
    Head,
    Link,
  },

  props: {
    canResetPassword: Boolean,
    status: String,
  },

  data() {
    return {
      form: this.$inertia.form({
        email: "",
        password: "",
        remember: false,
      }),
    };
  },

  methods: {
    submit() {
      this.form.post(this.route("login"), {
        onFinish: () => this.form.reset("password"),
      });
    },
  },
};
</script>
